<template>
    <div>
        <el-dialog :visible.sync="dialogVisible" width="60%">
            <!-- <el-divider></el-divider> -->
            <div v-if="detailData.pushMode == 1">
                <!-- HTTP -->
                <h4>基本信息</h4>
                <el-divider></el-divider>
                <el-form :inline="true" :model="detailData" class="demo-form-inline">
                    <el-form-item label="设备编号">
                        <el-input v-model="detailData.devCode" :readonly="true" ></el-input>
                    </el-form-item>
                    <el-form-item label="设备名称">
                        <el-input v-model="detailData.devName" :readonly="true"  style="width: 300px;"></el-input>
                    </el-form-item>
                    <el-form-item label="推送类型">
                        <el-input :readonly="true" v-model="pushType[detailData.pushType]"></el-input>
                    </el-form-item>
                    <el-form-item label="推送地址">
                        <el-input v-model="detailData.pushUrl" :readonly="true" style="width: 350px;"></el-input>
                    </el-form-item>
                    <el-form-item label="推送方式">
                        <el-input :readonly="true" v-model="pushMode[detailData.pushMode]"></el-input>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-input :readonly="true" v-model="pushStatus[detailData.pushStatus]"></el-input>
                    </el-form-item>
                    <el-form-item label="创建时间">
                        <el-input :readonly="true" v-model="detailData.createDate"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div v-if="detailData.pushMode == 2">
                <!-- RabbitMQ -->
                <h4>基本信息</h4>
                <el-divider></el-divider>
                <el-form :inline="true" :model="detailData" class="demo-form-inline">
                    <el-form-item label="设备编号">
                        <el-input v-model="detailData.devCode" :readonly="true"></el-input>
                    </el-form-item>
                    <el-form-item label="设备名称">
                        <el-input v-model="detailData.devName" :readonly="true"  style="width: 300px;"></el-input>
                    </el-form-item>
                    <el-form-item label="推送类型">
                        <el-input :readonly="true" v-model="pushType[detailData.pushType]"></el-input>
                    </el-form-item>
                    <el-form-item label="推送主题">
                        <el-input v-model="detailData.pushTopic" :readonly="true"></el-input>
                    </el-form-item>
                    <el-form-item label="缓存过期时间">
                        <el-input v-model="detailData.expirationTime" :readonly="true"></el-input>
                    </el-form-item>
                    <el-form-item label="密钥">
                        <el-input v-model="detailData.pushKey" :readonly="true"></el-input>
                    </el-form-item>
                    <el-form-item label="推送方式">
                        <el-input :readonly="true" v-model="pushMode[detailData.pushMode]"></el-input>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-input :readonly="true" v-model="pushStatus[detailData.pushStatus]"></el-input>
                    </el-form-item>
                    <el-form-item label="创建时间">
                        <el-input :readonly="true" v-model="detailData.createDate"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div style="margin-bottom: 80px;">
                <h4>失败原因</h4>
                <el-divider></el-divider>
                <span style="margin-left: 20px;">{{ detailData.failReason }}</span>
            </div>
            <div>
                <h4>推送信息</h4>
                <el-divider></el-divider>
                <!-- 设备JSON数据详情 -->
                <div style="margin-left: 30px;" v-if="detailData.pushType == 1">
                    <h6>基本数据</h6>
                    <el-divider></el-divider>
                    <el-form :inline="true" :model="pushList" class="demo-form-inline">
                        <el-form-item label="数据类型">
                            <el-input v-model="data_type[pushList.data_type]" :readonly="true"></el-input>
                        </el-form-item>
                        <el-form-item label="设备标识">
                            <el-input v-model="pushList.device_id" :readonly="true" style="width: 300px;"></el-input>
                        </el-form-item>
                        <el-form-item label="设备编号">
                            <el-input :readonly="true" v-model="pushList.device_code"></el-input>
                        </el-form-item>
                        <el-form-item label="设备名称">
                            <el-input v-model="pushList.device_name" :readonly="true"  style="width: 300px;"></el-input>
                        </el-form-item>
                        <el-form-item label="模组编号">
                            <el-input v-model="pushList.module_code" :readonly="true"></el-input>
                        </el-form-item>
                        <el-form-item label="上行包编号">
                            <el-input v-model="pushList.packet_code" :readonly="true"></el-input>
                        </el-form-item>
                        <el-form-item label="推送时间戳(毫秒)">
                            <el-input :readonly="true" v-model="pushList.event_time"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <div style="margin-left: 30px;" v-if="detailData.pushType == 1">
                    <h6>设备数据</h6>
                    <div v-for="item in pushList.device_data" :key="item.code">
                        <el-divider></el-divider>
                        <el-form :inline="true" :model="item" class="demo-form-inline">
                            <el-form-item label="指标编号">
                                <el-input v-model="item.code" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="指标名称">
                                <el-input v-model="item.name" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="指标值">
                                <el-input v-model="item.value"  :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="指标单位">
                                <el-input v-model="item.unit" :readonly="true"></el-input>
                            </el-form-item>
                        </el-form>
                    </div>

                    <el-divider></el-divider>
                </div>
                <!-- 设备上下线消息详情 -->
                <div style="margin-left: 30px;" v-if="detailData.pushType == 2">
                    <h6>基本数据</h6>
                    <el-divider></el-divider>
                    <el-form :inline="true" :model="pushList.alarm_info" class="demo-form-inline">
                        <el-form-item label="数据类型">
                            <el-input v-model="data_type[pushList.data_type]" :readonly="true"></el-input>
                        </el-form-item>
                        <el-form-item label="设备标识">
                            <el-input v-model="pushList.device_id" :readonly="true" style="width: 300px;"></el-input>
                        </el-form-item>
                        <el-form-item label="设备编号">
                            <el-input :readonly="true" v-model="pushList.device_code"></el-input>
                        </el-form-item>
                        <el-form-item label="设备名称">
                            <el-input v-model="pushList.device_name" :readonly="true"  style="width: 300px;"></el-input>
                        </el-form-item>
                        <el-form-item label="设备状态">
                            <el-input v-model="device_status[pushList.device_status]" :readonly="true"></el-input>
                        </el-form-item>
                        <el-form-item label="推送时间戳(毫秒)">
                            <el-input :readonly="true" v-model="pushList.event_time"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <!-- 设备告警数据详情 -->
                <div style="margin-left: 30px;" v-if="detailData.pushType == 3">
                    <h6>基本数据</h6>
                    <el-divider></el-divider>
                    <el-form :inline="true" :model="pushList" class="demo-form-inline">
                        <el-form-item label="推送时间戳(毫秒)">
                            <el-input :readonly="true" v-model="pushList.event_time"></el-input>
                        </el-form-item>
                        <el-form-item label="数据类型">
                            <el-input v-model="data_type[pushList.data_type]" :readonly="true"></el-input>
                        </el-form-item>
                        <el-form-item label="用户账号">
                            <el-input v-model="pushList.user_account" :readonly="true"></el-input>
                        </el-form-item>
                        <el-form-item label="用户昵称">
                            <el-input v-model="pushList.user_nickName" :readonly="true"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <div style="margin-left: 30px;" v-if="detailData.pushType == 3">
                    <h6>告警信息</h6>
                    <el-divider></el-divider>
                    <el-form :inline="true" :model="pushList.alarm_info" class="demo-form-inline">
                        <el-form-item label="告警名称">
                            <el-input :readonly="true" v-model="pushList.alarm_info.alarmName"></el-input>
                        </el-form-item>
                        <el-form-item label="告警级别">
                            <el-input v-model="alarmLevel[pushList.alarm_info.alarmLevel]" :readonly="true"></el-input>
                        </el-form-item>
                        <el-form-item label="告警描述">
                            <el-input v-model="pushList.alarm_info.alarmDescribe" :readonly="true"></el-input>
                        </el-form-item>
                        <el-form-item label="告警时间">
                            <el-input v-model="pushList.alarm_info.alarmTime" :readonly="true"></el-input>
                        </el-form-item>
                        <el-form-item label="设备ID">
                            <el-input :readonly="true" v-model="pushList.alarm_info.devId"></el-input>
                        </el-form-item>
                        <el-form-item label="设备编号">
                            <el-input :readonly="true" v-model="pushList.alarm_info.devCode"></el-input>
                        </el-form-item>
                        <el-form-item label="设备名称">
                            <el-input :readonly="true" v-model="pushList.alarm_info.devName"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div>
                <h4>JSON示例</h4>
                <el-divider></el-divider>
                <el-input v-model="newJSON" autosize type="textarea" resize="none" placeholder="Please input"
                    :readonly="true" />
            </div>
            <el-divider></el-divider>

            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">返回</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import API from "../../api/api";
export default {
    data() {
        return {
            dialogVisible: false,
            detailData: {},
            pushType: {
                1: '设备json数据',
                2: '设备上下线消息',
                3: '设备告警数据'
            },
            pushMode: {
                1: 'HTTP推送',
                2: 'RabbitMQ推送'
            },
            pushStatus: {
                0: '进行中',
                1: '成功',
                2: '失败'
            },
            device_status: {
                0: '离线',
                1: '在线'
            },
            data_type: {
                1: '设备数据',
                2: '设备状态',
                3: '告警数据'
            },
            alarmLevel: {
                1: '紧急',
                2: '重要',
                3: '次要',
                4: '提示'
            },
            newJSON: {},
            pushList: {}
        }
    },
    mounted() {
        //    this.show() 
    },
    methods: {
        show(row) {
            this.resetQuery()
            this.dialogVisible = true

            API.platformPushLogDetail(row.id).then(res => {
                this.detailData = res.data
                this.pushList = JSON.parse(res.data.detailJson)
                if (this.pushList.alarm_info) {
                    this.pushList.alarm_info.alarmTime = this.pushList.alarm_info.alarmTime.replace('T', ' ')
                }
                this.newJSON = JSON.stringify(JSON.parse(res.data.detailJson), null, '\t')

            })
        },
        // 重置resetQuery
        resetQuery() {
            this.$nextTick(() => {
                this.pushList = {},
                    this.newJSON = '',
                    this.detailData = {}
            })
        }
    },
}
</script>

<style lang="scss" scoped></style>


// WEBPACK FOOTER //
// src/views/platform/DataPushDetail.vue